import React from 'react';
import logo from '../../resources/bvt_logo_white.png';
import { paths } from '../../utils/paths';
import './Support.css';

const Header = (props) =>{

  let signup = props.signup;
  return (
    <header className="header">
      <div className="header-logo">
        <img src={logo} alt="Logo" />
      </div>
      {
        (props.signup) &&
        <nav className="header-nav">
          <a href={paths.auth.signup} className="signup-link">Sign Up</a>
        </nav>
      }
      {
        (props.login) &&
        <nav className="header-nav">
          <a href={paths.auth.signIn} className="signup-link">Login</a>
        </nav>
      }
    </header>
  );
};

export default Header;